import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionD');
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection
                hasAnimation={false}
                position="hoverR"
                pc="https://websiteoss.ecoflow.com/upload/image/1723537644404/a1.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1723537644678/a2.jpg"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
            />
        </div>
    );
}
